class EasyMarkets {

    static callbacks = [];

    // add any callback to execute when external APIs are loaded
    static ready(onSuccess) {
        if (typeof onSuccess === 'function') {
            this.callbacks.push(onSuccess);
        }
    }

    // Execute any neccessary callbacks after the external api was loaded
    static async resolve() {
        const props = ['geo', 'docCookies'];

		return new Promise((resolve, reject) => {
            try {
                const checkEMReady = setInterval(() => {
                    for (const prop of props) {
                        if (!window.easymarkets.hasOwnProperty(prop)) {
                            return;
                        }
                    }
                    clearInterval(checkEMReady);
                    resolve();
                }, 100);
            } catch (e) {
                reject(e);
            }
        }).then(() => {
            // ES6 script can run before all the EasyMarkets external API's are available.
            // Any attached callbacks will run here once API is ready and available
            // In short this a small Publish / Subscribe pattern used only for this class.
            for (const callback of this.callbacks) {
                callback();
            }

            // clear callbacks as they are not needed anymore
            this.callbacks = [];
        }).catch(console.error); // print first error called frome reject(e) if happens
    }
}

export default EasyMarkets;